import React from 'react'
import { withRouter } from 'react-router'
import { view } from 'react-easy-state'
import { Progress, Icon, Typography, Tooltip } from 'antd'
import globalStore from 'store'

class QuestionListSider extends React.Component {


  startVideo = (questionId) => {
    const { chapterId } = this.props.match.params

    this.props.history.push(`/chapters/${chapterId}/questions/${questionId}`)
  }

  render() {

    const pageState = globalStore.ui.students.questions.show

    const { question, all_questions, chapter } = pageState

    return (<div className="lecture-list-sider" id="questionListSider">
      {/* <div className="header">
        <Button shape="circle" onClick={this.props.goBack}><Icon type="left" /></Button>
        <Button shape="circle"><Icon type="setting" /></Button>
      </div> */}
      <div className="back-button" onClick={this.props.goBack}><Icon type="arrow-left"/> Back</div>
      <div className="course-detail-sider" style={{ padding: 0 }}>
        <div className="course-image">
          <img src={chapter.image_url} alt={chapter.name} />
        </div>
        <div className="course-name"><h3>{chapter && chapter.name}</h3></div>
        {false && <div className="course-progress">
          <Progress
            strokeColor={{
              '0%': '#108ee9',
              '100%': '#87d068',
            }}
            percent={(question && question.userProgress) || 0}
            strokeWidth={12}
            style={{ margin: '15px 0px' }}
          />
        </div>}
      </div>
      <div className="course-section-list">
        <div className="section-box">
          <ul>
            {
              all_questions && all_questions.map(q => {
                return <React.Fragment key={q.id}>
                  {false && <li className="section-name">{q.name}</li>}
                  <li className="lecture" onClick={() => this.startVideo(q.id)}>
                    {false && <div className="lecture-progress">
                      <Progress type="circle" strokeWidth={20} percent={q.userProgress || 0} width={20} showInfo={false} />
                    </div>}
                    <div className="lecture-name">
                      <Icon type="copy" style={{ width: 30 }} />
                      <Tooltip title={q.name}>
                        <Typography.Text
                          ellipsis
                          style={{ width: 'calc(100% - 30px)' }}>
                          {q.name}
                        </Typography.Text>
                      </Tooltip>
                    </div>
                  </li>
                </React.Fragment>
              })
            }
          </ul>
        </div>
      </div>
    </div>)
  }
}

export default withRouter(view(QuestionListSider))
